import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const interviewObservation = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    enthusiasmScore: z
      .number()
      .nullable()
      .optional()
      .describe('Score for enthusiasm and positivity.'),

    azerbaijaniLevel: z
      .enum(['Native', 'Excellent', 'Good', 'Satisfactory', 'Poor', 'None'])
      .nullable()
      .optional()
      .describe('Azerbaijani language level.'),

    englishLevel: z
      .enum(['Native', 'Excellent', 'Good', 'Satisfactory', 'Poor', 'None'])
      .nullable()
      .optional()
      .describe('English language level.'),

    russianLevel: z
      .enum(['Native', 'Excellent', 'Good', 'Satisfactory', 'Poor', 'None'])
      .nullable()
      .optional()
      .describe('Russian language level.'),

    persianLevel: z
      .enum(['Native', 'Excellent', 'Good', 'Satisfactory', 'Poor', 'None'])
      .nullable()
      .optional()
      .describe('Persian language level.'),

    frenchLevel: z
      .enum(['Native', 'Excellent', 'Good', 'Satisfactory', 'Poor', 'None'])
      .nullable()
      .optional()
      .describe('French language level.'),

    italianLevel: z
      .enum(['Native', 'Excellent', 'Good', 'Satisfactory', 'Poor', 'None'])
      .nullable()
      .optional()
      .describe('Italian language level.'),

    spanishLevel: z
      .enum(['Native', 'Excellent', 'Good', 'Satisfactory', 'Poor', 'None'])
      .nullable()
      .optional()
      .describe('Spanish language level.'),

    germanLevel: z
      .enum(['Native', 'Excellent', 'Good', 'Satisfactory', 'Poor', 'None'])
      .nullable()
      .optional()
      .describe('German language level.'),

    arabicLevel: z
      .enum(['Native', 'Excellent', 'Good', 'Satisfactory', 'Poor', 'None'])
      .nullable()
      .optional()
      .describe('Arabic language level.'),

    otherLanguage: z
      .string()
      .nullable()
      .optional()
      .describe('Other language spoken by the candidate.'),

    shiftPreference: z
      .enum(['Morning', 'Afternoon', 'Evening', 'Flexible'])
      .nullable()
      .optional()
      .describe('Preferred shift during the event.'),

    trainingAvailability: z
      .enum(['Weekdays', 'Weekends', 'Both'])
      .nullable()
      .optional()
      .describe('When the candidate can participate in trainings.'),

    lateShift: z
      .enum(['Yes', 'No'])
      .nullable()
      .optional()
      .describe('Whether the candidate can work late shifts.'),

    specialRequest: z
      .string()
      .nullable()
      .optional()
      .describe('Special request related to countries.'),

    needAdditionalCheck: z
      .enum(['Yes', 'No'])
      .nullable()
      .optional()
      .describe('Whether the candidate needs additional background check.'),

    totalScores: z
      .number()
      .nullable()
      .optional()
      .describe('Total interview scores.'),

    interviewId: z.number().hidden().describe('Foreign key to Interview'),

    interview: belongsTo('Interview'),
  })
  .describe(
    'Interviewer observations including enthusiasm, language skills, availability, and assignment.',
  )
  .as('InterviewObservation');

export { interviewObservation as interviewObservationSchema };
